import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import BaseStep from "../../../../../../../shared/wizard/steps/baseStep";

const SelectionByOwnBuyStep_9 = () => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_8);
  };

  const handleNextStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_10);
  };

  return (
    <div>
      <BaseStep
        prevStep={handlePrevStep}
        nextStep={handleNextStep}
        text="Нажимая 'Далее >' подтверждаю стоимость работы риелтора 2.5%"
      />
    </div>
  );
};

export default SelectionByOwnBuyStep_9;
